import { map } from 'nanostores';

export interface OpenTab {
  chatId: string;
  path: string;
  description?: string;
}

const MAX_TABS = 3;
const TABS_STORAGE_KEY = 'dunea-open-tabs';

function loadPersistedTabs(): OpenTab[] {
  try {
    const raw = sessionStorage.getItem(TABS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function persistTabs(tabs: OpenTab[]) {
  try {
    sessionStorage.setItem(TABS_STORAGE_KEY, JSON.stringify(tabs));
  } catch {
    // Storage full or unavailable
  }
}

export const chatStore = map({
  started: false,
  aborted: false,
  showChat: true,
  activeChat: '' as string,
  openTabs: loadPersistedTabs(),
});

export function addOpenTab(tab: OpenTab) {
  const tabs = [...chatStore.get().openTabs];
  const existingIndex = tabs.findIndex((t) => t.path === tab.path);

  if (existingIndex >= 0) {
    // Update existing tab's fields (e.g. description)
    tabs[existingIndex] = { ...tabs[existingIndex], ...tab };
  } else {
    if (tabs.length >= MAX_TABS) {
      // Evict the oldest tab that is NOT the currently active one
      const active = chatStore.get().activeChat;
      const evictIndex = tabs.findIndex((t) => t.path !== active);

      if (evictIndex >= 0) {
        tabs.splice(evictIndex, 1);
      } else {
        tabs.shift();
      }
    }

    tabs.push(tab);
  }

  chatStore.setKey('openTabs', tabs);
  persistTabs(tabs);
}

export function removeOpenTab(path: string) {
  const tabs = chatStore.get().openTabs.filter((t) => t.path !== path);
  chatStore.setKey('openTabs', tabs);
  persistTabs(tabs);
}

export function updateTabDescription(path: string, desc: string) {
  const tabs = chatStore.get().openTabs.map((t) => (t.path === path ? { ...t, description: desc } : t));
  chatStore.setKey('openTabs', tabs);
  persistTabs(tabs);
}

export function findTabByChat(chatIdOrUrlId: string): OpenTab | undefined {
  const path = `/chat/${chatIdOrUrlId}`;
  return chatStore.get().openTabs.find((t) => t.path === path || t.chatId === chatIdOrUrlId);
}
